import { render, staticRenderFns } from "./DetailUpdateModal.vue?vue&type=template&id=ca04330a&scoped=true&"
import script from "./DetailUpdateModal.vue?vue&type=script&lang=js&"
export * from "./DetailUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailUpdateModal.vue?vue&type=style&index=0&id=ca04330a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca04330a",
  null
  
)

export default component.exports